// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.pattern-table {
    font-family: Consolas, Monaco, monospace;
    border-collapse: collapse;
    cursor: default;
    user-select: none;
}

.pattern-table .playback-row {
    background-color: #ff0;
}

.pattern-table th {
    border: 1px solid #ccc;
    padding: 0 10px;
    font-weight: normal;
    text-align: right;
    color: #888;
}

.pattern-table td {
    border: 1px solid #ccc;
    padding: 0 10px;
}

.pattern-table td .note {
    padding: 0 10px;
}

.pattern-table td span:focus {
    outline: none;
    border-radius: 2px;
    box-shadow: 0 0 0 2px blue;
}

.pattern-table td.selected {
    background-color: #bee;
}
`, "",{"version":3,"sources":["webpack://./src/ui/panels/pattern_table.css"],"names":[],"mappings":"AAAA;IACI,wCAAwC;IACxC,yBAAyB;IACzB,eAAe;IACf,iBAAiB;AACrB;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,sBAAsB;IACtB,eAAe;IACf,mBAAmB;IACnB,iBAAiB;IACjB,WAAW;AACf;;AAEA;IACI,sBAAsB;IACtB,eAAe;AACnB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,kBAAkB;IAClB,0BAA0B;AAC9B;;AAEA;IACI,sBAAsB;AAC1B","sourcesContent":[".pattern-table {\n    font-family: Consolas, Monaco, monospace;\n    border-collapse: collapse;\n    cursor: default;\n    user-select: none;\n}\n\n.pattern-table .playback-row {\n    background-color: #ff0;\n}\n\n.pattern-table th {\n    border: 1px solid #ccc;\n    padding: 0 10px;\n    font-weight: normal;\n    text-align: right;\n    color: #888;\n}\n\n.pattern-table td {\n    border: 1px solid #ccc;\n    padding: 0 10px;\n}\n\n.pattern-table td .note {\n    padding: 0 10px;\n}\n\n.pattern-table td span:focus {\n    outline: none;\n    border-radius: 2px;\n    box-shadow: 0 0 0 2px blue;\n}\n\n.pattern-table td.selected {\n    background-color: #bee;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
